/* ═══════════════════════════════════════════════════════
   ONIALLY — Auto Table of Contents for Blog Articles
   Fichier : assets/blog-auto-toc.js
   
   Génère automatiquement un sommaire cliquable à partir
   des balises <h2> et <h3> de chaque article de blog.
   Le sommaire est inséré avant le premier <h2>.
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── 1. Trouver le conteneur de l'article ── */
  var articleBody = document.querySelector('.article-template__content')
    || document.querySelector('.article__content')
    || document.querySelector('.blog-article__content')
    || document.querySelector('[class*="article"] .rte')
    || document.querySelector('.rte');

  if (!articleBody) return;

  /* ── 2. Récupérer tous les h2 et h3 ── */
  var headings = articleBody.querySelectorAll('h2, h3');
  if (headings.length < 3) return; /* Pas de sommaire si moins de 3 titres */

  /* ── 3. Construire la liste ── */
  var tocHTML = '<div class="auto-toc">';
  tocHTML += '<div class="auto-toc__title">Sommaire</div>';
  tocHTML += '<ol class="auto-toc__list">';

  for (var i = 0; i < headings.length; i++) {
    var heading = headings[i];
    var text = heading.textContent.trim();

    /* Créer un id s'il n'en a pas */
    if (!heading.id) {
      heading.id = 'section-' + i;
    }

    var tag = heading.tagName.toLowerCase();

    if (tag === 'h2') {
      tocHTML += '<li class="auto-toc__item">';
      tocHTML += '<a href="#' + heading.id + '">' + text + '</a>';
      tocHTML += '</li>';
    } else if (tag === 'h3') {
      tocHTML += '<li class="auto-toc__item auto-toc__item--sub">';
      tocHTML += '<a href="#' + heading.id + '">' + text + '</a>';
      tocHTML += '</li>';
    }
  }

  tocHTML += '</ol></div>';

  /* ── 4. Insérer avant le premier h2 ── */
  var firstH2 = articleBody.querySelector('h2');
  if (firstH2) {
    firstH2.insertAdjacentHTML('beforebegin', tocHTML);
  }

  /* ── 5. Smooth scroll au clic ── */
  var tocLinks = document.querySelectorAll('.auto-toc__list a');
  for (var j = 0; j < tocLinks.length; j++) {
    tocLinks[j].addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = this.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (target) {
        var offset = 80; /* hauteur du header sticky */
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        /* Mettre à jour l'URL sans scroll */
        history.pushState(null, null, '#' + targetId);
      }
    });
  }

});